import { get } from 'helpers/api';
import { FETCH_DASHBOARD_DATA, DASHBOARD_DATA_FETCH_FAILED } from 'bundles/project/actions/index';

export const getDashboardData = dashboardPath => (
  (dispatch) => {
    return get(dashboardPath).then((dashboardData) => {
      dispatch({ type: FETCH_DASHBOARD_DATA, payload: dashboardData });
    }).catch(() => {
      dispatch({ type: DASHBOARD_DATA_FETCH_FAILED });
    });
  }
);
